import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppService } from '../../services/app.service';
import { MemberService } from '../../services/member.service';
import { map, switchMap, take } from 'rxjs/operators';

export const redirectAwayGuard: CanActivateFn = () => {
    const service = inject(AppService);
    const memberService = inject(MemberService);
    const router = inject(Router);

    return memberService.isAgent$.pipe(
        take(1),
        switchMap(isAgent => {
            if (isAgent) {
                return [router.createUrlTree(['my', 'dashboard'])];
            }
            return service.establishment$.pipe(
                take(1),
                map(establishment => {
                    if (establishment) {
                        return router.createUrlTree(['establishment', 'dashboard']);
                    }
                    return true;
                }),
            );
        }),
    );
};
